import PromisedResource from './PromisedResource'

function getOptions(year, month) {
  return {
    sources: {
      remote: {
        include: 'campaign_spends',
        settings: {
          params: {
            year: year,
            month: month,
          }
        }
      }
    }
  }
}

export default class AllocationsResource extends PromisedResource {
  constructor({remote, contractOrClient, month, year}) {
    super(remote.query(q => q.findRelatedRecords(contractOrClient, 'allocations'), getOptions(year, month)))
  }
}
